import axios from "axios";

export class InvitationService {
  async getPendingInvitation(spaceId: number, page: number): Promise<any> {
    return await axios.get(
      `/api/user_invitations?space=${spaceId}&page=${page}`
    );
  }
  async deleteInvitation(invitationId: number): Promise<any> {
    return await axios.delete(`/api/user_invitations/${invitationId}`);
  }
  async increaseInvitation(invitationId: number): Promise<any> {
    return await axios.put(
      `/api/user_invitations/${invitationId}/increase_expiration_time`,
      {}
    );
  }
}
